<div class="bg-black min-h-[280px] flex p-4 gap-4 flex-wrap" style="background-image: linear-gradient(rgba(35,35,35,0.5), rgba(35,35,35,0.5)), url('https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/mainServices/virtualTourBkg.png'); background-size: contain;background-position:center right;background-repeat: no-repeat;">
    <div class="gap-4 flex flex-col justify-between flex-1 min-w-0">
        <div class="flex flex-col">
            <span class="mt-2 typography-title-m" style="color: white">{{ 'menu.FABRICATOR.online-visit' | translate }}</span>
            <span class="mt-2 typography-body-s-light" style="color: white">{{ 'home.virtual_visit_banner_description' | translate }}</span>
        </div>
        <app-button [secondary]="true" size="l" class="w-full" (click)="goToVirtualVisit()">
            <span>{{ 'home.book_a_online_visit' | translate }}</span>
        </app-button>
    </div>
</div>